module.exports = __webpack_public_path__ + "3343be7172b55184d518b42226421c71.svg";